import { computed, ComputedRef, Ref } from 'vue'

import { OwnStatus } from '@/shared/types/store'

export function useStatusClass (currentStatus: Ref<OwnStatus>): {
  statusClasses: ComputedRef<string | null>,
} {
  const statusClasses = computed(() => {
    let result = null
    switch (currentStatus.value) {
    case OwnStatus.DEFAULT:
      result = 'bg-black-400'
      break
    case OwnStatus.ONLINE:
      result = 'bg-comp-avatar-status-online'
      break
    case OwnStatus.ABSENT:
      result = 'bg-comp-avatar-status-do-not-disturb'
      break
    case OwnStatus.DO_NOT_DISTURB:
      result = 'bg-comp-avatar-status-in-the-call'
      break
    default:
      break
    }
    return result
  })

  return {
    statusClasses,
  }
}
